export const ALL = 'all'
export const OPEN = 'open'
export const COMPLETED = 'completed'
export const DONE = 'done'
export const IGNORED = 'ignored'
export const IN_PROGRESS = 'inProgress'
